<template>
  <div>
     <!-- Button to trigger Edit -->
    <button v-if="displayType === 'dropdown-item'" @click="mergeDivisionsClicked" class="text-gray-900 group flex w-full items-center px-2 py-2 text-gray-800 hover:bg-gray-200">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mr-3 w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 8.25V6a2.25 2.25 0 00-2.25-2.25H6A2.25 2.25 0 003.75 6v8.25A2.25 2.25 0 006 16.5h2.25m8.25-8.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-7.5A2.25 2.25 0 018.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 00-2.25 2.25v6" />
      </svg>
      Merge Divisions
    </button>
    <button v-else @click="mergeDivisionsClicked" class="inline-flex items-center px-2 py-1 border border-transparent text-xs font-medium rounded text-gray-700 bg-gray-100 border-gray-200 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">Merge Divisions</button>
    <b-modal ref="mergeModal" title="Merge Divisions" no-close-on-backdrop>
      <div>
        <p class='text-lg my-2'>Choose the division to merge into and the division to merge. Any classes in the division to merge will be moved to the division to merge into.</p>
        <div class="mt-4">
          <p>Division to merge</p>
          <v-select :options="divisionList" label="label" v-model="mergeDivision" />
          <p class='text-sm text-gray-800'>Entries will be moved out of this division</p>
        </div>
        <div class="mt-4">
          <p>Division to merge into</p>
          <v-select :options="divisionList" label="label" v-model="baseDivision" />
          <p class='text-sm text-gray-800'>Entries will be moved into this division</p>
        </div>

        <div class="mt-4 bg-gray-200 p-3 rounded-md">
          <p class='text-lg'>Shows this will affect:</p>
          <ul class="mt-2">
            <li v-for="(s, i) in shows" :key="i">{{s.name}}</li>
          </ul>
        </div>
      </div>
      <div slot="modal-footer" class="w-full">
        <div class="flex justify-end">
          <button class="btn-green btn-sm mr-2" variant="primary" @click="mergeDivisions">
            Merge Divisions
          </button>
          <button class="btn-gray-outline btn-sm" @click="cancelMerge" variant="primary">
            Cancel
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    class_list_id: {
      default: null,
      type: String
    },
    shows: {
      default: () => [],
      type: Array
    },
    classConfiguration: {
      default: null,
      type: Object
    },
    displayType: {
      type: String,
      default: 'button'
    }
  },
  data () {
    return {
      baseDivision: null,
      mergeDivision: null
    }
  },
  methods: {
    mergeDivisionsClicked () {
      this.$refs.mergeModal.show()
    },
    cancelMerge () {
      this.$refs.mergeModal.hide()
      this.mergeDivision = null
      this.baseDivision = null
    },
    mergeDivisions () {
      this.shows.forEach(s => {
        this.$store.state.apiInstance.post('/entries/merge_divisions', {show_id: s.show_id, show_date: s.show_date, use_dynamic: true, base_division: this.baseDivision.value, merge_division: this.mergeDivision.value})
          .then(response => {
            if (response.data.data.toReview.length > 0) {
              alert(`${JSON.stringify(response.data.data.toReview)}`)
            }
          })
      })
    }
  },
  computed: {
    classList () {
      let cl = this.$store.state.admin.adminData.event.show_types.find(st => st.class_list_id === this.class_list_id)
      return cl ? cl.class_list : []
    },
    divisionList () {
      let div = []
      this.classList.forEach(c => {
        if (c.entryType.toLowerCase() === 'standard') {
          if (!div.find(d => d.value === c.division)) {
            div.push({
              label: c.settings.division_label ? c.settings.division_label : c.division,
              value: c.division,
              admin_only: c.settings.admin_only
            })
          }
        }
      })
      return div.sort((a, b) => {
        if (a.label < b.label) {
          return -1
        } else if (a.label > b.label) {
          return 1
        } else {
          return 0
        }
      })
    }
  }
}
</script>

<style>

</style>
